/**
 * The Flux→Zustand channel mirror debounces its asset/thread-items pass, so
 * a non-React reader of `channelVariants` (chiefly the save path) registers
 * the mirror's `flush` here to settle it before reading, rather than mapping
 * a stale variant. Mirrors `omniMirrorFlush`'s pattern, including the
 * no-bridge-mounted no-op.
 */
let flushChannelMirror: (() => void) | null = null

export function registerChannelMirrorFlush(flush: () => void): () => void {
  flushChannelMirror = flush
  return (): void => {
    flushChannelMirror = null
  }
}

export function getChannelMirrorFlush(): (() => void) | null {
  return flushChannelMirror
}
